var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('bootstrap-icon-picker',{key:_vm.id,attrs:{"disabled":_vm.disabled,"id":_vm.id,"name":_vm.name,"placeholder":_vm.placeholder,"required":_vm.required,"value":_vm.value,"type":_vm.type,"default-value":_vm.defaultValue},on:{"change":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }